<template>
    <div class="mr-4 md:mr-8 flex items-end">
        <div class="mr-4">
            <div class="hidden md:block text-xs text-gray-600 uppercase">Price name</div>
            <div class="sm:text-xl font-medium truncate">{{ name }}</div>
        </div>
        <div class="">
            <button @click="$root.$emit('edit-price-name')"
                    class="inline-block w-5 h-4">
                <IconPencil></IconPencil>
            </button>
        </div>
    </div>
</template>

<script>
import IconPencil from '@/components/icons/IconPencil'
export default {
    name: 'PriceName',
    props: {
        name: {
            type: String,
            default: ''
        }
    },
    components: {
        IconPencil
    }
}
</script>